// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3134":"88159d280b61c1b7","6332":"062d465bb8e04d15","8010":"5efa1690f337da2c"}[chunkId] + ".css";
};